import { ContainerTag } from "./admin/models_admin";
import { Citation } from "./citations";
import { JSONSchema7 } from "json-schema";

export type AskResponse = {
    answer: string;
    citations: Citation[];
    error?: string;
    assistantFileMessages?: ChatMessage[];
};

export type ToolMessageContent = {
    citations: Citation[];
    intent: string;
}

export type ChatMessage = {
    id: string;
    role: string;
    content: string;
    contentType?: string;
    fileName?: string;
    assistantFileID?: string;
    file_byte?: string;
    end_turn?: boolean;
    date: string;
    token_count?: number;
    user_feedback?: string;
};

export type Conversation = {
    id: string;
    title: string;
    messages: ChatMessage[];
    date: string;
    rag_ids?: number[];
    is_favorite?: boolean;
    user_id: string
    is_shared?: boolean
}

export type APIError = {
    error: string
}
export type ConversationWithError = Conversation & APIError

export enum ChatCompletionType {
    ChatCompletion = "chat.completion",
    ChatCompletionChunk = "chat.completion.chunk"
}

export type ChatResponseChoice = {
    messages: ChatMessage[];
}

type HistoryMetadata = {
    conversation_id: string;
    title: string;
    date: string;
}

export type ChatResponse = {
    id: string;
    model: string;
    created: number;
    object: ChatCompletionType;
    choices: ChatResponseChoice[];
    fileMessages?: ChatMessage[];
    history_metadata: HistoryMetadata;
    create_file?: ChatMessage[];
    error?: any;
}

export type ConversationRequest = {
    messages: ChatMessage[];
};

export type UserInfo = {
    access_token: string;
    expires_on: string;
    id_token: string;
    provider_name: string;
    user_claims: any[];
    user_id: string;
};

export enum CosmosDBStatus {
    NotConfigured = "CosmosDB is not configured",
    NotWorking = "CosmosDB is not working",
    Working = "CosmosDB is configured and working",
}

export type CosmosDBHealth = {
    cosmosDB: boolean,
    status: string
}

export enum ChatHistoryLoadingState {
    Loading = "loading",
    Success = "success",
    Fail = "fail",
    NotStarted = "notStarted"
}

export type ErrorMessage = {
    title: string,
    subtitle: string
}

export type DialogMessage = {
    onClose: (value: string) => void,
    title: string,
    subtitle: string
}

export type MessageType = {
    level: number;
    word: string
}

export type LoginUserInfo = {
    id: string;
    name: string;
    authlevel:number
}
export type TagUsageType = boolean;
export type TagOptions = {
    tag_keys: string[];
    match_all: boolean
    use_tags: TagUsageType
}

export type DocumentSearchToolArg = {
    tag_options: Map<string, TagOptions>
}

export type RAGMenuItem = {
    id: number;
    name: string;
    prompt_examples: string[];
    tags: ContainerTag[] | null;
};

export type RAGSummaryFileInfo = {
    filename: string;
    tag_keys: string[]|null;
}

export type RAGSummaryInfo = {
    files: RAGSummaryFileInfo[];
    total_count: number
}

export type ToolInfo = {
    name: string
    display_name: string
    icon_name: string | null
    description: string | null
    arg_schema: JSONSchema7 | null
}
export type ModelInfo = {
    name: string
    tools: ToolInfo[]
    is_free: boolean
}

// 以下プロンプトテンプレート系
export type PromptTemplateCategory = {
    id: number
    name: string
}

export type PromptTemplateVarInputType = "Text" | "PullDown" | "File" | "TranscribeFile"

export interface PromptTemplateVar {
  id: string;
  name: string;
  description: string;
  is_required: boolean;
  input_type: PromptTemplateVarInputType;
  elements: string[];
}

export interface PromptTemplateFile {
    file_name: string;
    file_name_in_blob: string;
}

export interface PromptTemplateSchema {
  system_prompt: string;
  request_prompt: string;
  tools: string[];
  rag_ids: number[]
  chat_model: string;
  vars: PromptTemplateVar[];
  files: PromptTemplateFile[];
}

export type PromptTemplate = {
    id: number,
    category_id: number
    company_cd: number | null
    description: string
    name: string,
    schema: PromptTemplateSchema
    owner_id: string | null
}

export type PromptTemplateOverrideInfo = {
    id: number
    name: string
}

// 非同期タスクのステータス（汎用）
export type TaskStatus = 'pending' | 'processing' | 'completed' | 'failed' | 'aborted'
export type TaskType = 'transcribe'

export type AsyncTaskStatus = {
    task_id: string
    task_type: TaskType
    status: TaskStatus
    progress: number
    result?: any  // タスクタイプに応じた結果
    partial_result?: any
    error?: string
}

// 議事録
export type TranscribeTaskStatus = TaskStatus
export type TranscribeStatus = AsyncTaskStatus & {
    task_type: 'transcribe'
    result?: string
}

// お知らせ情報
export type InfoItem = {
    start_date: string;
    content: string;
}

export type InfoResponse = {
    info_list: InfoItem[];
    info_history: InfoItem[];
}

export type GeneratingConversationInfo = {
    history_metadata: HistoryMetadata;
    file_messages: ChatMessage[];
    task_id: string;
}